import React from 'react';
import { SECTORS } from '../../utils/sectors';

const DOT_COLOURS = {
  green:   'bg-green-500',
  amber:   'bg-amber-400',
  red:     'bg-red-500',
  unknown: 'bg-gray-200',
};

/**
 * Six coloured dots showing sector status at a glance.
 * Used in the admin member table.
 *
 * Props:
 *   sectors — { financial: { status }, career: { status }, … }
 */
export default function SectorDots({ sectors }) {
  // Default params only cover `undefined`, not `null` — a member with no
  // sector_scores rows at all comes back as null from the admin members
  // query, not {}, and that silently crashed this component with no error
  // boundary anywhere to catch it. Confirmed 2026-09-02 against the real
  // admin Members page, same underlying pattern as the Dashboard.jsx bug
  // fixed earlier the same day.
  const safeSectors = sectors || {};
  return (
    <div className="flex items-center gap-1.5">
      {SECTORS.map(s => {
        const status = safeSectors[s.key]?.status || 'unknown';
        return (
          <span key={s.key} title={`${s.label}: ${status}`} className="relative group">
            <span
              className={`block w-3 h-3 rounded-full ${DOT_COLOURS[status]}`}
            />
            {/* Tooltip */}
            <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1
                             hidden group-hover:block bg-reset-brown text-white
                             text-[10px] px-2 py-0.5 rounded whitespace-nowrap z-10">
              {s.emoji} {s.label}: {safeSectors[s.key]?.score?.toFixed(1) ?? '—'}
            </span>
          </span>
        );
      })}
    </div>
  );
}
